import React from 'react'
import Button from 'components/button'
import FileIcon from 'static/icons/doc.svg'
import Zero from 'static/icons/numbers/zero.svg'
import One from 'static/icons/numbers/one.svg'
import Two from 'static/icons/numbers/two.svg'
import Three from 'static/icons/numbers/three.svg'
import Four from 'static/icons/numbers/four.svg'
import Five from 'static/icons/numbers/five.svg'
import Six from 'static/icons/numbers/six.svg'
import Seven from 'static/icons/numbers/seven.svg'
import Eight from 'static/icons/numbers/eight.svg'
import Nine from 'static/icons/numbers/nine.svg'

import { assetPrefix } from 'src/config/env_config'
import * as S from './styles'

const SchedulingTerms = ({ onClose }) => {
  return (
    <>
      <S.Header>
        <S.IconContainer>
          <FileIcon />
        </S.IconContainer>
        <S.Title>Termo e condições de uso</S.Title>
      </S.Header>

      <S.ImageContainer>
        <img src={`${assetPrefix}/static/images/scheduling-term.png`} />
      </S.ImageContainer>
      <S.Container>

        <S.Info>
          <p>Ao agendar serviços de banho e tosa ou atendimento clínico veterinário em nossas unidades franqueadas, o(a) cliente declara estar ciente e de acordo com as condições abaixo descritas.</p>
        </S.Info>

        <S.Content>
          <S.ContentTitleContainer>
            <S.IconContainer>
              <One />
            </S.IconContainer>
            <S.ContentTitle>Natureza da Rede Pet Anjo</S.ContentTitle>
          </S.ContentTitleContainer>

          <p>1.1. Cada unidade é administrada de forma independente por um franqueado, que responde pela execução dos serviços contratados.</p>
          <br />
          <p>1.2. A franqueadora atua como licenciadora da marca e fornecedora de suporte à rede, não participando diretamente da prestação dos serviços. Assim, eventuais questões decorrentes da execução ficam sob responsabilidade do franqueado local.</p>
        </S.Content>

        <S.Content>
          <S.ContentTitleContainer>
            <S.IconContainer>
              <Two />
            </S.IconContainer>
            <S.ContentTitle>Tolerância de Atrasos</S.ContentTitle>
          </S.ContentTitleContainer>

          <p>2.1. O agendamento é realizado com hora marcada, sendo realizado via aplicativo, telefone ou presencialmente.</p>
          <br />
          <p>2.2. Atrasos de até 10 minutos serão tolerados, sem prejuízo da realização do serviço.</p>
          <br />
          <p>2.3. Após esse prazo, a unidade poderá remarcar o atendimento conforme disponibilidade, sem garantia de execução no mesmo dia.</p>
        </S.Content>

        <S.Content>
          <S.ContentTitleContainer>
            <S.IconContainer>
              <Three />
            </S.IconContainer>
            <S.ContentTitle>Triagem Prévia e valores </S.ContentTitle>
          </S.ContentTitleContainer>

          <p>3.1. Antes do atendimento, o pet poderá passar por uma breve triagem para avaliação de saúde, comportamento e condições gerais.</p>
          <br />
          <p>3.2. Na clínica veterinária, essa triagem poderá incluir verificação de sinais vitais, histórico clínico, vacinação e exames prévios.</p>
          <br />
          <p>3.3. Caso sejam identificadas situações que comprometam a segurança ou o bem-estar do animal ou da equipe, o atendimento poderá ser recusado ou condicionado à assinatura de termo específico.</p>
          <br />
          <p>3.4. Os agendamentos realizados pelo aplicativo têm como base as informações cadastradas pelo tutor (raça, porte, peso e condição do pet), contudo, no momento da chegada à unidade será feita uma avaliação técnica presencial, ocasião em que poderão ser ajustados o tempo necessário para a execução do serviço e os valores previamente informados, caso sejam constatadas diferenças em relação aos dados registrados no agendamento online, sendo o início do atendimento condicionado à concordância do tutor com tais ajustes. </p>
        </S.Content>

        <S.Content>
          <S.ContentTitleContainer>
            <S.IconContainer>
              <Four />
            </S.IconContainer>
            <S.ContentTitle>Desembolo e Cuidados Especiais </S.ContentTitle>
          </S.ContentTitleContainer>

          <p>4.1. Em casos de pelagem com nós ou excesso de sujeira, poderá ser necessária a realização de desembolo ou outros procedimentos adicionais, os quais serão previamente informados ao tutor e poderão implicar custo adicional e extensão do tempo de atendimento.</p>
        </S.Content>

        <S.Content>
          <S.ContentTitleContainer>
            <S.IconContainer>
              <Five />
            </S.IconContainer>
            <S.ContentTitle>Pets com Temperamento Agressivo ou Ansioso</S.ContentTitle>
          </S.ContentTitleContainer>

          <p>5.1. Animais com comportamento agressivo ou que ofereçam risco à equipe poderão ter o atendimento recusado, interrompido ou condicionado à utilização de contenção adequada.</p>
          <br />
          <p>5.2. A decisão caberá ao responsável pela execução do serviço, no momento do atendimento.</p>
        </S.Content>

        <S.Content>
          <S.ContentTitleContainer>
            <S.IconContainer>
              <Six />
            </S.IconContainer>
            <S.ContentTitle>Filhotes, Idosos e Animais com Condições Especiais</S.ContentTitle>
          </S.ContentTitleContainer>

          <p>6.1. Animais filhotes, idosos ou portadores de doenças preexistentes requerem cuidados diferenciados, podendo haver limitações nos serviços prestados.</p>
          <br />
          <p>6.2. O tutor deverá informar previamente o estado de saúde do pet e apresentar laudos ou prescrições médicas, quando aplicável.</p>
          <br />
          <p>6.3. Durante a realização do serviço, o tutor deverá permanecer presente para acompanhar e auxiliar, sempre que necessário.</p>
        </S.Content>

        <S.Content>
          <S.ContentTitleContainer>
            <S.IconContainer>
              <Seven />
            </S.IconContainer>
            <S.ContentTitle>Atendimento a Felinos</S.ContentTitle>
          </S.ContentTitleContainer>

          <p>7.1. Para gatos, recomenda-se que o tutor utilize caixa de transporte adequada, visando a segurança durante deslocamento e triagem.</p>
          <br />
          <p>7.2. O atendimento poderá ser condicionado a ambiente controlado e medidas adicionais de contenção.</p>
          <br />
          <p>7.3. Durante a realização do serviço, o tutor deverá permanecer presente para acompanhar e auxiliar, sempre que necessário.</p>
        </S.Content>

        <S.Content>
          <S.ContentTitleContainer>
            <S.IconContainer>
              <Eight />
            </S.IconContainer>
            <S.ContentTitle>Animais com Doenças Preexistentes</S.ContentTitle>
          </S.ContentTitleContainer>

          <p>8.1. O tutor deve comunicar previamente qualquer condição clínica ou uso contínuo de medicamentos.</p>
          <br />
          <p>8.2. Em casos específicos, a realização do serviço poderá depender da apresentação de atestado veterinário autorizando o procedimento.</p>
          <br />
          <p>8.3. Durante a realização do serviço, o tutor deverá permanecer presente para acompanhar e auxiliar, sempre que necessário.</p>
        </S.Content>

        <S.Content>
          <S.ContentTitleContainer>
            <S.IconContainer>
              <Nine />
            </S.IconContainer>
            <S.ContentTitle>Termo de Responsabilidade</S.ContentTitle>
          </S.ContentTitleContainer>

          <p>9.1. Para alguns serviços e situações especiais (ex.: desembolo severo, contenção para animais agressivos, pets com doenças pré-existentes), poderá ser exigida a assinatura de Termo de Responsabilidade, autorizando a execução do atendimento.</p>
        </S.Content>

        <S.Content>
          <S.ContentTitleContainer>
            <S.IconContainer>
              <One />
              <Zero />
            </S.IconContainer>
            <S.ContentTitle>Política de Não Comparecimento</S.ContentTitle>
          </S.ContentTitleContainer>

          <p>10.1. Caso não seja possível comparecer na data e horário agendados, solicitamos que o serviço seja reagendado ou cancelado com, no mínimo, 24 horas de antecedência.</p>
        </S.Content>

        <S.Content>
          <S.ContentTitleContainer>
            <S.IconContainer>
              <One />
              <One />
            </S.IconContainer>
            <S.ContentTitle>Aceite</S.ContentTitle>
          </S.ContentTitleContainer>

          <p>11.1. Ao confirmar o agendamento, o cliente declara ter lido, compreendido e aceitado integralmente os presentes Termos e Condições.</p>
        </S.Content>

        <S.Content>
          <S.ContentTitleContainer>
            <S.IconContainer>
              <One />
              <Two />
            </S.IconContainer>
            <S.ContentTitle>Limitação de Responsabilidade</S.ContentTitle>
          </S.ContentTitleContainer>

          <p>12.1. Apesar de todos os cuidados adotados, situações de risco inerentes a procedimentos com animais podem ocorrer (ex.: arranhões, estresse, pequenas reações cutâneas a produtos).</p>
          <br />
          <p>12.2. O tutor declara estar ciente desses riscos e concorda que a unidade não se responsabiliza por reações imprevisíveis ou decorrentes de doenças ou condições pré-existentes.</p>
        </S.Content>

        <S.Content>
          <S.ContentTitleContainer>
            <S.IconContainer>
              <One />
              <Three />
            </S.IconContainer>
            <S.ContentTitle>Produtos Utilizados</S.ContentTitle>
          </S.ContentTitleContainer>

          <p>13.1. As unidades utilizam produtos de uso profissional, registrados nos órgãos competentes.</p>
          <br />
          <p>13.2. O tutor deve informar previamente sobre alergias conhecidas ou reações adversas anteriores.</p>
        </S.Content>

        <S.Content>
          <S.ContentTitleContainer>
            <S.IconContainer>
              <One />
              <Four />
            </S.IconContainer>
            <S.ContentTitle>Responsabilidade do Tutor</S.ContentTitle>
          </S.ContentTitleContainer>

          <p>14.1. O tutor é responsável por fornecer informações verídicas e completas sobre a saúde, comportamento e histórico do pet.</p>
          <br />
        </S.Content>

        <S.Content>
          <S.ContentTitleContainer>
            <S.IconContainer>
              <One />
              <Five />
            </S.IconContainer>
            <S.ContentTitle>Alterações nos Termos</S.ContentTitle>
          </S.ContentTitleContainer>

          <p>15.1. Estes Termos e Condições poderão ser atualizados periodicamente, sendo aplicável sempre a versão vigente no momento do agendamento.</p>
          <br />
        </S.Content>

      </S.Container>
      <S.Footer>
        <Button theme='secondary' onClick={() => onClose()}>Fechar</Button>
      </S.Footer>
    </>
  )
}

export default SchedulingTerms
